import { c as _c } from "react/compiler-runtime";
import './departure-cta-leaving.scss';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { getChildBioPath, getDeparturePath } from '@sola/my-sdk/constants.ts';
import type { GraphQLCommitment, GraphQLDepartureChild } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentAvatar } from '../../atoms/commitment-avatar/commitment-avatar.tsx';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
export type DepartureCtaLeavingProps = {
  child: GraphQLDepartureChild;
  commitment?: GraphQLCommitment;
  showChildDetailsCta?: boolean;
};
export const DepartureCtaLeaving: React.FC<DepartureCtaLeavingProps> = t0 => {
  const $ = _c(36);
  const {
    child,
    commitment,
    showChildDetailsCta: t1
  } = t0;
  const showChildDetailsCta = t1 === undefined ? true : t1;
  const {
    t
  } = useTranslation("my");
  const t2 = child.displayName ?? "";
  let t3;
  let t4;
  if ($[0] !== t || $[1] !== t2) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const name = t2.trim();
      if (!name) {
        t4 = null;
        break bb0;
      }
      t3 = t("my:sponsorshipRelationship.departures.cta.title", {
        name
      });
    }
    $[0] = t;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const title = t3;
  let t5;
  if ($[4] !== t) {
    t5 = t("my:sponsorshipRelationship.departures.cta.subtitle");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const subtitle = t5;
  let t6;
  if ($[6] !== child.globalId) {
    t6 = getChildBioPath(child.globalId);
    $[6] = child.globalId;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const detailsHref = t6;
  let t7;
  if ($[8] !== child.globalId) {
    t7 = getDeparturePath(child.globalId);
    $[8] = child.globalId;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const updateHref = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("DepartureCtaLeaving");
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== commitment) {
    t9 = <PrimaryCtaIcon><CommitmentAvatar commitment={commitment} size="lg" responsive={true} /></PrimaryCtaIcon>;
    $[11] = commitment;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== title) {
    t10 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[13] = title;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== subtitle) {
    t11 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[15] = subtitle;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <PrimaryCtaBody>{t10}{t11}</PrimaryCtaBody>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t) {
    t13 = t("my:sponsorshipRelationship.departures.cta.update.title");
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== updateHref) {
    t14 = <div className="flex"><ButtonStyle variant="secondary" size="md"><Link href={updateHref}>{t13}</Link></ButtonStyle></div>;
    $[22] = t13;
    $[23] = updateHref;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== detailsHref || $[26] !== showChildDetailsCta || $[27] !== t) {
    t15 = showChildDetailsCta && <ButtonStyle variant="tertiary" size="md" iconAfter={<ArkIcon iconName="arrow-narrow-right" />}><Link href={detailsHref}>{t("my:sponsorshipRelationship.departures.cta.details.title")}</Link></ButtonStyle>;
    $[25] = detailsHref;
    $[26] = showChildDetailsCta;
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <PrimaryCtaActions reverseOnDesktop={true}>{t14}{t15}</PrimaryCtaActions>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16 || $[34] !== t9) {
    t17 = <PrimaryCta variant="default" size="sm" className={t8}>{t9}{t12}{t16}</PrimaryCta>;
    $[32] = t12;
    $[33] = t16;
    $[34] = t9;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
};